import { takeLatest, call, put } from 'redux-saga/effects';

import { checkIfAPIResponseIsSuccess } from 'utils/functions/general';

import { getStaticData, getCompanyProfiles } from './api';
import {
  fetchStaticDataSuccess,
  fetchStaticDataFail,
  fetchCompanyProfilesListSuccess,
  fetchCompanyProfilesListFail,
  setSelectedCompanyProfile,
} from './actions';
import commonActionTypes from './action-types';

function* fetchStaticDataSaga({ payload }) {
  try {
    const response = yield call(getStaticData, payload);

    if (checkIfAPIResponseIsSuccess(response.status) === false) throw new Error(response.status);

    yield put(fetchStaticDataSuccess(response.data.data));
  } catch (error) {
    yield put(fetchStaticDataFail(error));
  }
}

function* fetchCompanyProfilesListSaga({ payload }) {
  try {
    const response = yield call(getCompanyProfiles, payload);

    if (
      response?.data?.data?.results?.length &&
      (!sessionStorage.getItem('companyEmailAuthCookie') ||
        !sessionStorage.getItem('companyProfileKeyAuthCookie'))
    ) {
      const firstCompanyInList = response.data.data.results[0];
      const { name, email, companyProfileKey, profileHashedKey } = firstCompanyInList;

      sessionStorage.setItem('companyNameAuthCookie', name);
      sessionStorage.setItem('companyEmailAuthCookie', email);
      sessionStorage.setItem('companyProfileKeyAuthCookie', companyProfileKey);
      sessionStorage.setItem('companyProfileHashedKeyAuthCookie', profileHashedKey);

      yield put(
        setSelectedCompanyProfile({
          email,
          token: companyProfileKey,
        }),
      );
    }

    if (checkIfAPIResponseIsSuccess(response.status) === false) throw new Error(response.status);

    yield put(fetchCompanyProfilesListSuccess(response.data.data));
  } catch (error) {
    fetchCompanyProfilesListFail(error);
  }
}

function* commonSaga() {
  yield takeLatest(commonActionTypes.FETCH_STATIC_DATA, fetchStaticDataSaga);
  yield takeLatest(commonActionTypes.FETCH_COMPANY_PROFILES_LIST, fetchCompanyProfilesListSaga);
}

export default commonSaga;
